<ng-container>
	<div *ngIf="data?.current; else newLimitContent">
		<img obgImageContent="general.warning" />
		<h1 class="obg-m-multi-session-limit-confirmation-title">
			{{ "multi-session-limit.update.confirmation-title" | translate }}
		</h1>
		<p
			class="obg-m-multi-session-limit-confirmation-caption"
			*ngIf="isUpcomingRestricting(data.upcoming, data.current)"
		>
			{{ "multi-session-limit.update.restricting-caption" | translate }}
		</p>
		<p
			class="obg-m-multi-session-limit-confirmation-caption"
			*ngIf="!isUpcomingRestricting(data.upcoming, data.current)"
		>
			{{ "multi-session-limit.update.loosening-caption" | translate }}
		</p>

		<div class="obg-m-multi-session-limit-confirmation-message">
			<p>
				<strong>{{ "multi-session-limit.update.from" | translate }}</strong>
			</p>
			<p class="obg-m-multi-session-limit-confirmation-value">
				<span>{{ getSessionLimitValue(data.current, getSessionLimitPeriod(data.current)) }} </span>
				<span>{{
					"multi-session-limit.update." + getPeriodText(getSessionLimitPeriod(data.current)) | translate
				}}</span>
			</p>
			<p>
				<strong>{{ "multi-session-limit.update.to" | translate }}</strong>
			</p>
			<p class="obg-m-multi-session-limit-confirmation-value">
				<span>{{ getSessionLimitValue(data.upcoming, getSessionLimitPeriod(data.upcoming)) }} </span>
				<span>{{
					"multi-session-limit.update." + getPeriodText(getSessionLimitPeriod(data.upcoming)) | translate
				}}</span>
			</p>

			<div class="obg-m-multi-session-limit-confirmation-question">
				<p *ngIf="isUpcomingRestricting(data.upcoming, data.current)">
					<strong>{{ "multi-session-limit.update.confirmation-restriction" | translate }}</strong>
				</p>
				<p>{{ "multi-session-limit.update.confirmation-question" | translate }}</p>
			</div>
		</div>
	</div>

	<ng-template #newLimitContent>
		<img obgImageContent="general.warning" />
		<h1 class="obg-m-multi-session-limit-confirmation-title">
			{{ "multi-session-limit.update.confirmation-title" | translate }}
		</h1>
		<p [innerHTML]="'multi-session-limit.update.confirmation-caption' | translate"></p>
	</ng-template>

	<button
		class="obg-m-multi-session-limit-confirmation-button"
		color="accent"
		test-id="alert-button-general.confirm"
		data-test-id="alert-button-general.confirm"
		mat-flat-button
		(click)="onConfirm()"
	>
		{{ "general.continue" | translate }}
	</button>
	<button
		class="obg-m-multi-session-limit-confirmation-button"
		color="primary"
		test-id="alert-button-general.cancel"
		data-test-id="alert-button-general.cancel"
		mat-stroked-button
		(click)="onCancel()"
	>
		{{ "general.cancel" | translate }}
	</button>
</ng-container>
